var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentationQuickAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documentation",
    clipPath: "url(#clip0_3563_6297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10.5C20 4.975 15.525 0.5 10 0.5C4.475 0.5 0 4.975 0 10.5C0 16.025 4.475 20.5 10 20.5C15.525 20.5 20 16.025 20 10.5Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.6875 17.3748C6.05 17.3748 5.4875 16.8998 5.3625 16.2623L5.3375 16.2123V16.0748V16.0123C4.7 16.0123 4.15 15.5498 4.025 14.9123L4 14.8623V14.7123V5.2123C4 4.3248 4.6875 3.6123 5.55 3.6123H13.1625C13.9375 3.6123 14.575 4.2123 14.6875 4.9748C15.45 5.0623 16.05 5.7498 16.05 6.5623V15.9623C16.05 16.7248 15.4375 17.3623 14.6875 17.3623H6.7L6.6875 17.3748Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.33828 15.1999C5.06328 15.1999 4.82578 14.9749 4.80078 14.6874V5.2374C4.80078 4.8124 5.12578 4.4624 5.52578 4.4624H13.1383C13.5383 4.4624 13.8633 4.8124 13.8633 5.2374V14.6374C13.8633 14.9499 13.6258 15.2124 13.3258 15.2124H5.33828V15.1999Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.1367 4.6874C13.3992 4.6874 13.6242 4.9249 13.6242 5.2249V14.6249C13.6242 14.8124 13.4867 14.9624 13.3242 14.9624H5.33672C5.17422 14.9624 5.03672 14.8124 5.03672 14.6249V5.2249C5.03672 4.9249 5.24922 4.6874 5.52422 4.6874H13.1367ZM13.1367 4.2124H5.52422C4.99922 4.2124 4.57422 4.6624 4.57422 5.2249V14.7499C4.63672 15.1374 4.96172 15.4374 5.34922 15.4374H13.3367C13.7617 15.4374 14.1117 15.0749 14.1117 14.6374V5.2249C14.1117 4.6624 13.6867 4.2124 13.1617 4.2124H13.1367Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.1371 4.6875H5.52461C5.26211 4.6875 5.03711 4.925 5.03711 5.225V5.9C5.03711 5.6 5.24961 5.3625 5.52461 5.3625H13.1371C13.3996 5.3625 13.6246 5.6 13.6246 5.9V5.225C13.6246 4.925 13.4121 4.6875 13.1371 4.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.68789 16.5498C6.40039 16.5498 6.17539 16.3123 6.15039 16.0123V6.57481C6.15039 6.14981 6.47539 5.7998 6.87539 5.7998H14.4879C14.8879 5.7998 15.2004 6.14981 15.2004 6.57481V15.9748C15.2004 16.2873 14.9629 16.5498 14.6629 16.5498H6.67539H6.68789Z",
    fill: "#E9EEF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.4883 6.0377C14.7508 6.0377 14.9758 6.2752 14.9758 6.5752V15.9752C14.9758 16.1627 14.8383 16.3127 14.6758 16.3127H6.68828C6.52578 16.3127 6.38828 16.1627 6.38828 15.9752V6.5752C6.38828 6.2752 6.60078 6.0377 6.87578 6.0377H14.4883ZM14.4883 5.5752H6.87578C6.35078 5.5752 5.92578 6.0252 5.92578 6.5877V16.1002C5.98828 16.4877 6.31328 16.7877 6.70078 16.7877H14.6883C15.1133 16.7877 15.4633 16.4252 15.4633 15.9877V6.5877C15.4633 6.0252 15.0383 5.5752 14.5133 5.5752H14.4883Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.4867 6.0376H6.87422C6.61172 6.0376 6.38672 6.2751 6.38672 6.5751V7.2501C6.38672 6.9501 6.59922 6.7126 6.87422 6.7126H14.4867C14.7492 6.7126 14.9742 6.9501 14.9742 7.2501V6.5751C14.9742 6.2751 14.7617 6.0376 14.4867 6.0376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.88672 7.1875H8.26172C8.02009 7.1875 7.82422 7.38338 7.82422 7.625V9.2625C7.82422 9.50412 8.02009 9.7 8.26172 9.7H9.88672C10.1283 9.7 10.3242 9.50412 10.3242 9.2625V7.625C10.3242 7.38338 10.1283 7.1875 9.88672 7.1875Z",
    fill: "#805AD1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.88789 9.9252H8.26289C7.88789 9.9252 7.58789 9.6252 7.58789 9.2502V7.6252C7.58789 7.2502 7.88789 6.9502 8.26289 6.9502H9.88789C10.2629 6.9502 10.5629 7.2502 10.5629 7.6252V9.2502C10.5629 9.6252 10.2629 9.9252 9.88789 9.9252ZM8.26289 7.4252C8.15039 7.4252 8.06289 7.5127 8.06289 7.6252V9.2502C8.06289 9.3627 8.15039 9.4502 8.26289 9.4502H9.88789C10.0004 9.4502 10.0879 9.3627 10.0879 9.2502V7.6252C10.0879 7.5127 10.0004 7.4252 9.88789 7.4252H8.26289Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.4492 11.0751H7.74922C7.62422 11.0751 7.51172 10.9751 7.51172 10.8376C7.51172 10.7001 7.61172 10.6001 7.74922 10.6001H13.4492C13.5742 10.6001 13.6867 10.7001 13.6867 10.8376C13.6867 10.9751 13.5867 11.0751 13.4492 11.0751Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.4492 13.2377H7.74922C7.62422 13.2377 7.51172 13.1377 7.51172 13.0002C7.51172 12.8627 7.61172 12.7627 7.74922 12.7627H13.4492C13.5742 12.7627 13.6867 12.8627 13.6867 13.0002C13.6867 13.1377 13.5867 13.2377 13.4492 13.2377Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.4125 14.3251H7.7375C7.6125 14.3251 7.5 14.2251 7.5 14.0876C7.5 13.9501 7.6 13.8501 7.7375 13.8501H10.4125C10.5375 13.8501 10.65 13.9501 10.65 14.0876C10.65 14.2251 10.55 14.3251 10.4125 14.3251Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.41172 15.4125H7.74922C7.62422 15.4125 7.51172 15.3125 7.51172 15.175C7.51172 15.0375 7.61172 14.9375 7.74922 14.9375H9.41172C9.53672 14.9375 9.64922 15.0375 9.64922 15.175C9.64922 15.3125 9.54922 15.4125 9.41172 15.4125Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.5258 12.1249H12.2883C12.1633 12.1249 12.0508 12.0249 12.0508 11.8874C12.0508 11.7499 12.1508 11.6499 12.2883 11.6499H13.5258C13.6508 11.6499 13.7633 11.7499 13.7633 11.8874C13.7633 12.0249 13.6633 12.1249 13.5258 12.1249Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.5617 12.1249H7.74922C7.62422 12.1249 7.51172 12.0249 7.51172 11.8874C7.51172 11.7499 7.61172 11.6499 7.74922 11.6499H11.5617C11.6867 11.6499 11.7992 11.7499 11.7992 11.8874C11.7992 12.0249 11.6992 12.1249 11.5617 12.1249Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3563_6297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationQuickAction);
export default __webpack_public_path__ + "static/media/DocumentationQuickAction.1f77dcbf33fa263dd30fc3272c749f28.svg";
export { ForwardRef as ReactComponent };